"use client";

import Link from "next/link";
import styles from "./CarCardClient.module.scss";
import { EventType, trackEventWithCommonProps } from "@utils/eventTracker";

export const CarCardClientWrapper = ({
  slug,
  children,
  modelName,
  brandName,
  cityName,
  carouselSection,
  carAvailability,
  pageType,
}: any) => {
  const handleClick = async () => {
    await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
      pageType: pageType,
      additionalProps: {
        action_type: "tap_btn",
        action_name: "tap_btn_similar_cars",
        ...(carouselSection && { section: carouselSection }),
        car_availability: carAvailability,
        city_name: cityName,
        vehicle_make: brandName,
        vehicle_model: modelName,
      },
    });
  };

  return (
    <Link
      href={`/cars/${slug}`}
      onClick={handleClick}
      className={styles.wrapper}
    >
      {children}
    </Link>
  );
};
